<div class="im:card portal">
  <label class="header">
    <span class="logo">
      <img src="{{ portalConfig()?.imgUrl }}" alt="" />
    </span>
    <span class="im:body name">
      {{ portalConfig()?.fullName | translate }}
    </span>
    <span class="checkbox">
      <input
        type="checkbox"
        class="im:checkbox-input"
        [formControl]="checkControl"
      />
    </span>
  </label>
  @if (selected()) {
    <div class="details">
      @switch (formType) {
        @case (credentialFormType.IMMOSCOUT) {
          <app-immoscout-credential-details
            [portalConfig]="portalConfig()"
            [credential]="credential"
            [formControl]="credentialDetailsControl"
            (getIs24URL)="onGetIs24URL()"
          >
          </app-immoscout-credential-details>
        }
        @case (credentialFormType.HOMEPAGE_MODULE) {
          <app-homepage-module-credential-details
            [portalConfig]="portalConfig()"
            [credential]="credential"
            [formControl]="credentialDetailsControl"
          >
          </app-homepage-module-credential-details>
        }
        @case (credentialFormType.RESIDENT_APP) {
          <app-resident-credential-details
            [portalConfig]="portalConfig()"
            [credential]="credential"
            [formControl]="credentialDetailsControl"
          >
          </app-resident-credential-details>
        }
        @case (credentialFormType.WILLHABEN) {
          <app-portal-credential-details-with-provider
            [portalConfig]="portalConfig()"
            [credential]="credential"
            [formControl]="credentialDetailsControl"
          >
          </app-portal-credential-details-with-provider>
        }
        @case (credentialFormType.IMMOBILIE1) {
          <app-portal-credential-details-with-provider
            [portalConfig]="portalConfig()"
            [credential]="credential"
            [formControl]="credentialDetailsControl"
          >
          </app-portal-credential-details-with-provider>
        }
        @case (credentialFormType.CS_PRO) {
          <app-portal-credential-details-with-provider
            [portalConfig]="portalConfig()"
            [credential]="credential"
            [formControl]="credentialDetailsControl"
          >
          </app-portal-credential-details-with-provider>
        }
        @case (credentialFormType.DEFAULT) {
          <app-portal-credential-details
            [portalConfig]="portalConfig()"
            [credential]="credential"
            [formControl]="credentialDetailsControl"
          >
          </app-portal-credential-details>
        }
      }
    </div>
  }
</div>
